/**
 * Stats blocks: when section enters view, animate numbers from 0 to final value (GSAP).
 */
(function () {
  function initStatsBlocks() {
    if (typeof gsap === "undefined") {
      setTimeout(initStatsBlocks, 50);
      return;
    }

    var sections = document.querySelectorAll('section[id^="stats-blocks-"]');
    sections.forEach(function (section) {
      if (section.dataset.statsAnimated === "true") return;
      const duration = parseInt(section.dataset.duration);
      var numberEls = section.querySelectorAll(".stats-blocks__number");
      if (!numberEls.length) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            section.dataset.statsAnimated = "true";

            numberEls.forEach(function (numberEl) {
              var inner = numberEl.querySelector(".stats-blocks__number-inner");
              if (!inner) return;

              var raw = numberEl.dataset.value || "0";
              var target = parseFloat(raw) || 0;
              var suffix = numberEl.dataset.appendPercent === "true" ? "%" : "";
              var obj = { value: 0 };

              gsap.to(obj, {
                value: target,
                duration: duration,
                ease: "power2.out",
                onUpdate: function () {
                  var v = obj.value;
                  inner.textContent =
                    (target % 1 !== 0 ? v.toFixed(1) : Math.round(v)) + suffix;
                },
              });
            });
          });
        },
        { rootMargin: "0px 0px -80px 0px", threshold: 0.1 }
      );

      observer.observe(section);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initStatsBlocks);
  } else {
    initStatsBlocks();
  }

  document.addEventListener("shopify:section:load", initStatsBlocks);
})();
